// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_landing__Link from "../../components/html/Link.js";
import * as Buhta_landing__Route from "../../Route.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function LibraryArticles(Props) {
  let pages = Props.pages;
  let pageNum = Props.pageNum;
  let slug = Props.slug;
  const language = Buhta_landing__Route.getLanguage(undefined);
  let firstPage;
  try {
    firstPage = Stdlib__List.hd(pages);
  }
  catch (exn){
    firstPage = {
      title: "",
      description: "",
      id: "",
      slug: ""
    };
  }
  let otherPages;
  try {
    otherPages = Stdlib__List.tl(pages);
  }
  catch (exn$1){
    otherPages = /* [] */ 0;
  }
  let secondPage;
  try {
    secondPage = Stdlib__List.hd(otherPages);
  }
  catch (exn$2){
    secondPage = {
      title: "",
      description: "",
      id: "",
      slug: ""
    };
  }
  let anotherPages;
  try {
    anotherPages = Stdlib__List.tl(otherPages);
  }
  catch (exn$3){
    anotherPages = /* [] */ 0;
  }
  let thirdPage;
  try {
    thirdPage = Stdlib__List.hd(anotherPages);
  }
  catch (exn$4){
    thirdPage = {
      title: "",
      description: "",
      id: "",
      slug: ""
    };
  }
  return JsxRuntime.jsxs("div", {
    children: [
      pageNum === 0 && slug === "" ? JsxRuntime.jsxs(React.Fragment, {
          children: [
            JsxRuntime.jsxs(Buhta_landing__Link.make, {
              route: {
                TAG: /* Landing */ 0,
                _0: /* COUNTRY_KAZ */ 1,
                _1: language,
                _2: {
                  TAG: /* LibraryArticle */ 6,
                  _0: firstPage.slug
                }
              },
              className: "bg-bg rounded-sm p-6 lg:p-12 block",
              children: [
                JsxRuntime.jsx("h5", {
                  children: firstPage.title,
                  className: "h6 lg:h5 text-black-heading"
                }),
                JsxRuntime.jsx("p", {
                  children: firstPage.description,
                  className: "paragraph text-gray-landing lg:w-80 mt-2"
                })
              ]
            }),
            JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs(Buhta_landing__Link.make, {
                  route: {
                    TAG: /* Landing */ 0,
                    _0: /* COUNTRY_KAZ */ 1,
                    _1: language,
                    _2: {
                      TAG: /* LibraryArticle */ 6,
                      _0: secondPage.slug
                    }
                  },
                  className: "lg:w-96 bg-primary-variant rounded-sm p-6 lg:p-8 block",
                  children: [
                    JsxRuntime.jsx("h5", {
                      children: secondPage.title,
                      className: "h6 lg:h5 text-white"
                    }),
                    JsxRuntime.jsx("p", {
                      children: secondPage.description,
                      className: "paragraph text-white lg:w-62 mt-2"
                    })
                  ]
                }),
                JsxRuntime.jsxs(Buhta_landing__Link.make, {
                  route: {
                    TAG: /* Landing */ 0,
                    _0: /* COUNTRY_KAZ */ 1,
                    _1: language,
                    _2: {
                      TAG: /* LibraryArticle */ 6,
                      _0: thirdPage.slug
                    }
                  },
                  className: "lg:w-96 bg-secondary rounded-sm p-6 lg:p-8 mt-4 lg:mt-0 block",
                  children: [
                    JsxRuntime.jsx("h5", {
                      children: thirdPage.title,
                      className: "h6 lg:h5 text-white"
                    }),
                    JsxRuntime.jsx("p", {
                      children: thirdPage.description,
                      className: "paragraph text-white lg:w-62 mt-2"
                    })
                  ]
                })
              ],
              className: "lg:flex justify-between mt-4 lg:mt-8"
            }),
            JsxRuntime.jsx("hr", {
              className: "mt-6 lg:mt-10 text-divider"
            }),
            JsxRuntime.jsx("h6", {
              children: "Все темы",
              className: "h6 text-black-landing mt-6 lg:mt-10"
            })
          ]
        }) : null,
      JsxRuntime.jsx("div", {
        children: Belt__Belt_List.toArray(Stdlib__List.map((function (page) {
          const Key = page.id;
          return JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(Buhta_landing__Link.make, {
                route: {
                  TAG: /* Landing */ 0,
                  _0: /* COUNTRY_KAZ */ 1,
                  _1: language,
                  _2: {
                    TAG: /* LibraryArticle */ 6,
                    _0: page.slug
                  }
                },
                className: "paragraph-medium text-black-landing",
                children: page.title
              }),
              JsxRuntime.jsx("p", {
                children: page.description,
                className: "paragraph-small text-gray-landing mt-0.5"
              })
            ],
            className: "lg:w-61 mt-3 lg:mt-4"
          }, Key);
        }), pages)),
        className: "flex flex-wrap justify-between"
      })
    ],
    className: "lg:w-200 sm:px-48 lg:px-0"
  });
}

const make = LibraryArticles;

export {
  make,
}
/* Buhta_landing__Link Not a pure module */
